import { type CSSProperties, type KeyboardEvent, type MouseEvent } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { getClickableToastHandlerForTarget } from '@apps/web/lib/clickable_toasts';

function clickedToastControl(target: EventTarget | null): boolean {
    return (
        target instanceof Element &&
        target.closest('[data-close-button], [data-button]') !== null
    );
}

function Toaster({ ...props }: ToasterProps) {
    const handleClickCapture = (event: MouseEvent<HTMLDivElement>) => {
        if (clickedToastControl(event.target)) {
            return;
        }

        const onClick = getClickableToastHandlerForTarget(event.target);
        if (onClick === null) {
            return;
        }

        onClick();
    };

    const handleKeyDownCapture = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        if (clickedToastControl(event.target)) {
            return;
        }

        const onClick = getClickableToastHandlerForTarget(event.target);
        if (onClick === null) {
            return;
        }

        event.preventDefault();
        onClick();
    };

    return (
        <div
            onClickCapture={handleClickCapture}
            onKeyDownCapture={handleKeyDownCapture}
        >
            <Sonner
                className="toaster group"
                style={
                    {
                        '--normal-bg': 'var(--popover)',
                        '--normal-text': 'var(--popover-foreground)',
                        '--normal-border': 'var(--border)',
                    } as CSSProperties
                }
                {...props}
            />
        </div>
    );
}

export { Toaster };
